import React from "react";
import { withRouter } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import { ToastContainer, toast } from "react-toastify";
import ReCAPTCHA from 'react-google-recaptcha';
import axios from "axios";
import { BsGlobe } from "react-icons/bs";
import { HiWifi } from "react-icons/hi";
import { SlLocationPin } from "react-icons/sl";
import Loader from "react-js-loader";
import moment from "moment";
import Pulse from 'react-reveal/Pulse';

import nielit_logo from "../assets/nielit_logo.png"
import meity_logo from "../assets/meity_logo.png"
import "./home.css";
import "react-toastify/dist/ReactToastify.css";


class auth extends React.Component {
  updateTimeInterval = null;

  constructor(props) {
    super(props);
    this.state = {
      switchView: true,
      browserName: "",
      ip: "",
      country: "India",
      iframeLoaded: false,
      iframeError: false,
      machineID:  "",
      user: "",
      password: "",
      noMachineIDModal: false,
      inUseModal: false,
      route: ""
    };

  }
  successToast() {
    toast.success('Form Submitted', {
      position: "bottom-center",
      autoClose: 2200,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  }
  handleRecaptchaChange = () => {
    let token = this.captchaFunction.getValue();
    if(token){
      toast.success('CAPTCHA Verified', {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setTimeout(() => {
        window.open(this.state.route, "_blank");
        //this.setState({ switchView: false });
      }, 1000);
    }
  };
  async componentDidMount() {
    const { id } = this.props.match.params;

    if (id) {
      this.getVMDetails();
    } else {
      this.setState({ noMachineIDModal: true });
    }

    // Get Browser Name
    const userAgent = navigator.userAgent;
    let browserName = "Unknown";

    if (userAgent.includes("Chrome")) {
      browserName = "Google Chrome";
    } else if (userAgent.includes("Firefox")) {
      browserName = "Mozilla Firefox";
    } else if (userAgent.includes("Safari")) {
      browserName = "Apple Safari";
    } else if (userAgent.includes("Edge")) {
      browserName = "Microsoft Edge";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      browserName = "Opera";
    } else if (userAgent.includes("Trident")) {
      browserName = "Microsoft Internet Explorer";
    }

    this.setState({ browserName });

    // Get IP and Country
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      this.setState({
        country: `${data.region}, ${data.country_name}`,
        ip: data.org,
      });
    } catch (error) {
      console.log("Error fetching IP details:", error);
    }
  }
  async getVMDetails() {
    const { id } = this.props.match.params;
    const storedID = localStorage.getItem("vmID");

    let token =
      "0pZXN;i8`2@#zwyprqti3j9eyJhbGdvIjoiSFMyNTYiLCJ0eXBlIjoiSldUIiw;{iZXhwaXJlIjoxNjkxNTc2ODY1fQ==.eyJ1c2VyX2lkIjoxMiwid0938dGltZSI6MTY5MTU3Njg2NX0=.ZmE1MGM2NzNjZWEsxMjUdfdfwYjdmMDFkOTsdfsJlOWY2N}zJkYTM1Mjcfddwdf3MzFkNDJmOWJm0dMDIzYTM4M2MzNjgwMGNiNjA3Mg==!!0ojiwgadfaaJK98!";

    let formData = new FormData();
    formData.append("vm_id", id);

    try {
      const response = await fetch("https://nielitcybersec.in/admin/api/getVMDetails.php", {
        method: "POST",
        headers: { Authorization: "Bearer " + token },
        body: formData,
      });

      const responseJson = await response.json();
      if (responseJson.vm_id) {
        let username = responseJson.username.trim();
        let password = responseJson.password.trim();
        const lastAccessed = responseJson.last_accessed;
        const lastAccessedMoment = moment(lastAccessed, "Do MMMM YYYY, hh:mm:ss A");

        const now = moment(); // Current time
        const diffInMinutes = now.diff(lastAccessedMoment, "minutes");

        console.log(storedID, id, diffInMinutes);

        if (diffInMinutes < 10 && id !== storedID) {
          this.setState({ inUseModal: true });
        } else {
          this.setState({
            machineID: id,
            route: `http://14.139.200.9:8080/guacamole/#/client/${id}?username=${username}&password=${password}`,
          });
          this.startUpdateTimeInterval();
          this.updateTime();
          if (storedID !== id) {
            localStorage.setItem("vmID", id);
          }
        }
      } else {
        this.setState({ noMachineIDModal: true });
      }
    } catch (error) {
      console.error("Error fetching VM details:", error);
    }
  }
  startUpdateTimeInterval() {
    if (!this.updateTimeInterval) {
      this.updateTimeInterval = setInterval(() => {
        this.updateTime();
      }, 60000); // Call updateTime every 1 minute
    }
  }
  stopUpdateTimeInterval() {
    if (this.updateTimeInterval) {
      clearInterval(this.updateTimeInterval);
      this.updateTimeInterval = null;
    }
  }
  async updateTime() {
    const { id } = this.props.match.params;
    let token =
      "0pZXN;i8`2@#zwyprqti3j9eyJhbGdvIjoiSFMyNTYiLCJ0eXBlIjoiSldUIiw;{iZXhwaXJlIjoxNjkxNTc2ODY1fQ==.eyJ1c2VyX2lkIjoxMiwid0938dGltZSI6MTY5MTU3Njg2NX0=.ZmE1MGM2NzNjZWEsxMjUdfdfwYjdmMDFkOTsdfsJlOWY2N}zJkYTM1Mjcfddwdf3MzFkNDJmOWJm0dMDIzYTM4M2MzNjgwMGNiNjA3Mg==!!0ojiwgadfaaJK98!";

    let formData = new FormData();
    formData.append("vm_id", id);

    try {
      const response = await fetch("https://nielitcybersec.in/admin/api/updateVMActivity.php", {
        method: "POST",
        headers: { Authorization: "Bearer " + token },
        body: formData,
      });

      const responseJson = await response.json();
      if (responseJson.Status === "Last Access Time updated") {
        console.log("VM activity updated successfully.");
      }
    } catch (error) {
      console.error("Error updating VM activity:", error);
    }
  }
  componentWillUnmount() {
    this.stopUpdateTimeInterval();
  }
  handleIframeLoad = () => {
    this.setState({
      iframeLoaded: true
    })
  }
  handleIframeError = () => {
    console.log("ERROR")
    this.setState({
      iframeError: true
    })
  }
  render() {
    const {iframeLoaded, route} = this.state;
    return (
      <div className="container_box">
        <Modal
          show={this.state.noMachineIDModal}
          backdrop="static"
          keyboard={false}
          centered
          size="md"
        >
          <ModalBody>
            <div style={{padding: 7}}>
              <p className="login_header_text">Warning</p>
              <center>
                <p className="emailVerifyHeader_register">Invalid Virtual Machine ID</p>
                <p className="viewExam_WarnModalSubtitles">You're trying to access a virtual machine with an invalid machine ID. Please check and try again.</p>
              </center>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          show={this.state.inUseModal}
          backdrop="static"
          keyboard={false}
          centered
          size="md"
        >
          <ModalBody>
            <div style={{padding: 7}}>
              <p className="login_header_text">Warning</p>
              <center>
                <p className="emailVerifyHeader_register">Virtual Machine already in-use</p>
                <p className="viewExam_WarnModalSubtitles">You're trying to access a virtual machine which is already in-use. Please try later.</p>
              </center>
            </div>
          </ModalBody>
        </Modal>
        {
          this.state.switchView ?
            <div className="container_inner">
               
               <img src={meity_logo} className="meity_logo"/>
              <img src={nielit_logo} className="nielit_logo"/>
              
              <br clear="all"/>
              <Pulse bottom>
                <h1 className="dashboard_bodyTitle">Implement Practical Learnings with<br/><p className="dashboard_bodyTitle_gradient">Virtual Training Lab</p></h1>
                <center>
                  <ReCAPTCHA
                    ref={ref => (this.captchaFunction = ref)}
                    sitekey="6LfuaJonAAAAAKDObMmXzpa2XvQrIKcte44PGuV6"
                    onChange={this.handleRecaptchaChange}
                  />
                </center>
                <Row style={{marginTop:"7%"}}>
                  <Col md={4} sm={4} xs={4}>
                    <p className="connectionTxt"><BsGlobe size={22} className="loc-icons"/><br className="forMobile"/> {this.state.browserName}</p>
                  </Col>
                  <Col md={4} sm={4} xs={4}>
                    <p className="connectionTxt"><HiWifi size={22} className="loc-icons"/><br className="forMobile"/> {this.state.ip}</p>
                  </Col>
                  <Col md={4} sm={4} xs={4}>
                    <p className="connectionTxt"><SlLocationPin size={22} className="loc-icons"/><br className="forMobile"/> {this.state.country}</p>
                  </Col>
                </Row>
              </Pulse>
            </div>
          :
          <div className="iframe-container">
           {!iframeLoaded && (
              <div className="loader-overlay">
                  <Loader
                      type="spinner-circle"
                      bgColor={"#b5b5b5"}
                      title={""}
                      color={"#b5b5b5"}
                      size={80}
                  />
              </div>
            )}
            <iframe
                src={route}
                title=""
                className={`full-iframe ${iframeLoaded ? 'loaded' : ''}`}
                onLoad={this.handleIframeLoad}
                onError={this.handleIframeError}
                sandbox="allow-scripts allow-same-origin allow-forms allow-modals"
            />
          </div>
        }
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    )
  }
}
export default withRouter(auth);
